import React, {Component} from 'react';
import {connect} from "react-redux";
import './supplier.scss';

//components
import BranchesMap from '../shared/branches-map';

//assets
import top_banner_mobile from 'assets/mock/top-banner-mobile-supplier.jpg';
import top_banner_desktop from 'assets/mock/top-banner-supplier-desktop.jpg';
// import benefit_mock from 'assets/mock/benefit-mock.jpg';
import benefit_mock from 'assets/images/landing-background-mobile.jpg'; /// delete
import side_icon from 'assets/benefit-icons/icon-coupon-pay-blue.svg';
import Benefit from "../shared/benefit/benefit";
import {cleanUpObject} from "../../app/functions";


class Supplier extends Component{

    constructor(props){
        super(props);

        this.getAllBenefits = this.getAllBenefits.bind(this);
        this.getAllCities = this.getAllCities.bind(this);
        this.cityOnChange = this.cityOnChange.bind(this);
    }

    getAllBenefits(){
        const data = [{image:benefit_mock ,icon:side_icon ,title:'סוהו' ,discount:'525,000' ,old_price:'הנחה' ,sub_text:'במיקום הכי טוב בקרית אונו! נותרו עוד 2 מקומות בלבד' },
            {image:benefit_mock ,icon:side_icon ,title:'איטלסופה', discount:'40% הנחה'  ,sub_text:'במיקום הכי טוב בקרית אונו! נותרו עוד 2 מקומות בלבד' },
            {image:benefit_mock ,icon:side_icon ,title:'מבצע בלעדי!' ,discount:'560' ,old_price:'980' ,sub_text:'במיקום הכי טוב בקרית אונו! נותרו עוד 2 מקומות בלבד' }];

        let res = [];

        data.forEach((item,index)=>{
            item.more_details = this.props.deviceState === 'mobile' ? '' : 'פרטים נוספים';
            res.push(
                <Benefit className='benefit' data={item}/>
            )
        });

        return res;
    }


    getAllCities(){
        const data = ['אשדוד','חיפה','תל אביב'];
        let res = [];

        data.forEach((item,index) =>{
            res.push({text:item, id:index});
        });

        return res;
    }



    cityOnChange(id){
        this.setState({city:{...this.state.city, selected : id}});
    }

    render(){
        const isMobile = this.props.deviceState === 'mobile';
        return(
            <section className='supplier'>
                <div className='top-banner'>
                    <img className='bg-img' src={isMobile ? top_banner_mobile : top_banner_desktop} alt='/'/>
                    <div className='title-wrapper'>
                        <h3 className='title'>ריקושט</h3>
                        <span className='sub-title'>כל טיול מתחיל בריקושט</span>
                    </div>
                </div>

                <div className='benefits-container'>
                    {this.getAllBenefits()}
                </div>

                <div className='about'>
                    <h3 className='about-title'>על העסק</h3>
                    <div className='about-para'>
                        מהי חבילת ספורט תיירותית? מה היא כוללת בתוכה ומדוע היא משתלמת יותר עבור אוהדי הספורט בישראל? כל מה שצריך לדעת על חבילות ספורט תיירותיות במאמר שלפניכם.
                        בעידן הגלובאלי בו אנו חיים, אנו יכולים בלחיצת כפתור אחת לצפות בשידורי ספורט מכל העולם. ההיצע הגדול של שידורי הספורט מרחבי העולם העומד לרשות אוהדי הספורט בישראל, מאפשר לכל אחד ואחת מהם לעקוב באופן רציף אחר קבוצות ספורט שונות מכל העולם. בנוסף להיצע השידורים המגוון של שידורי הספורט מהעולם, לרשות אוהדי הספורט בישראל עומדת האפשרות להיות נוכחים בזמן אמת באצטדיוני הספורט המובילים ביותר בעולם.

                        וכל זאת באמצעות חבילות ספורט תיירותיות המשלבות בתוכן גם חוויה ספורטיבית מרגשת  וגם חוויה תיירותית מהנה ומפנקת כאח. חבילות הספורט התיירותיות המשווקת לקהל אוהדי הספורט בישראל, כוללות בתוכן בעיקר חבילות אירוח המיועדות לצרכי צפייה במשחקי הכדורגל של מועדוני הספורט הגדולים ביותר בעולם.
                    </div>
                </div>
                <BranchesMap cities={this.getAllCities()}/>
            </section>
        )
    }
}


//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        benefitTypes: cleanUpObject(store.config.IconTypes),
    }
};

const mapDispatchToProps = dispatch => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Supplier);
